<template>
  <v-menu
    ref="menu1"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="dateFormatted"
      :label="label"
      persistent-hint
      prepend-icon="event"
      @blur="date = parseDate(dateFormatted)"
      :rules="rules"
      :disabled="true"
      class="enabled"
    />
    <v-date-picker
      v-model="date"
      no-title
      @input="menu = false"
    />
  </v-menu>
</template>

<script>
  export default {
    name: 'DatePicker',
    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
    },
    data: () => ({
      date: null,
      dateFormatted: null,
      menu: false,
    }),

    computed: {
      computedDateFormatted() {
        return this.formatDate(this.date);
      },
    },

    watch: {
      date() {
        this.dateFormatted = this.formatDate(this.date);
      },
      value() {
        this.date = this.parseDate(this.value);
      },
    },

    methods: {
      formatDate(date) {
        if (!date) {
          return null;
        }

        const [year, month, day] = date.split('-');
        this.$emit('input', `${day}.${month}.${year}`);
        return `${day}.${month}.${year}`;
      },
      parseDate(date) {
        if (!date) {
          return null;
        }

        const [day, month, year] = date.split('.');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
    },
  };
</script>

<style scoped>
  .enabled {

  }

</style>
